// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1n3DF","label":"LabeledBox_label__SC6o3"};